import { addition, subtract } from "@/utils/count";
import formatterMixin from "./formatterMixin";
export default {
  mixins: [formatterMixin],
  data() {
    return {};
  },
  methods: {
    // 对数组(arr)，指定参数(key)相同的进行合并，并对这些相同的指定价格参数(priceKey)进行加总，最后返回一个合并相同项和相同项加总金额的数组
    mergeSameAttrList(arr, key, priceKey) {
      if (!Array.isArray(arr)) return [];
      const map = new Map();
      arr.forEach(item => {
        const keyValue = item[key];
        // 只有当 key 存在时才处理
        if (keyValue !== undefined && keyValue !== null && keyValue !== "") {
          if (map.has(keyValue)) {
            // 如果 Map 中已存在，取出引用进行累加
            const existingItem = map.get(keyValue);
            // 解析当前项数值
            const currentVal = item[priceKey];
            const existingVal = existingItem[priceKey];
            // 更新累加值
            existingItem[priceKey] = addition(existingVal, currentVal);
          } else {
            // 如果不存在，存入 Map（注意：为了不修改原数据，建议浅拷贝）
            map.set(keyValue, { ...item });
          }
        }
      });
      // 将 Map 的值转回数组
      return Array.from(map.values());
    },
    // 服务列表价格加总
    serviceListPriceSum(list, currency) {
      if (!Array.isArray(list) || !list.length) return "";
      let sum = 0;
      for (let i = 0; i < list.length; i++) {
        const { thirdPartyFee = 0, otherFee = 0, serviceFee = 0 } = list[i];
        sum = addition(sum, thirdPartyFee, otherFee, serviceFee);
      }
      // 返回带货币符号的千分位金额
      return this.currencyAndAmountFormat(currency, sum);
    },
    // 计算已选中服务列表的价格总和
    listTotalCalculation(list) {
      if (!list || list.length === 0) {
        return { isMismatch: false, text: "0.00" };
      }
      // 使用 Set 判断 currency 是否完全一致
      const currencies = new Set(list.map(item => item.currency));
      if (currencies.size > 1) {
        // 货币不一致时返回提示并附加标志位以便绑定 red 类名
        return { isMismatch: true, text: "Currency inconsistency, unable to calculate" };
      }
      // 货币一致时进行数值转换并累加求和
      const currency = Array.from(currencies)[0];
      const sum = list.reduce((acc, item) => addition(acc, item.serviceFee), 0);
      // 返回计算后的金额（借用原有格式化方法），并确保 isMismatch 为 false
      return {
        isMismatch: false,
        text: this.currencyAndAmountFormat(currency, sum),
      };
    },
    // 服务费(Service Charge) = 总价(amount) - 第三方费用(Third party fee) - 其他费用(Other Fee)
    serviceChargeCalculation(amount, thirdPartyFee, otherFee) {
      const serviceCharge = subtract(amount, thirdPartyFee, otherFee);
      return serviceCharge;
    },
  },
};
